import styled from '@emotion/styled';
import { CardBasic } from '__components/Card/Card';
import { SizedCell, SortableHeadCell } from '__components/Kizen/Table';
import Section from '__components/Layout/Section';
import SubNavigation from 'components/Navigation/SubNavigation';

export const SectionWrapper = styled.div`
  padding: 0;
  margin: 0 20px 40px;
`;

export const PageCard = styled(CardBasic)`
  min-height: 500px;
  max-height: 500px;
  max-width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  margin-bottom: 20px;
  > div:last-of-type {
    flex: 1;
  }
`;

export const StyledSortableHeadCell = styled(SortableHeadCell)`
  > div {
    // Fixes small alignment issue with cell text
    line-height: 0;
    margin-top: 1px;
    button {
      margin-left: 10px;
    }
  }
`;

export const StyledActionSizedCell = styled(SizedCell)`
  > div {
    display: flex;
    justify-content: flex-end;
  }
`;

export const StyledSection = styled(Section)`
  padding: 0;
  margin: 0 20px 40px;
`;

export const StyledSubNavigation = styled(SubNavigation)`
  && a {
    padding-bottom: 10px !important;
  }
`;
